// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3Rn1i","description":"PatientConsentPreview_description__3v76t"};